import { gql, useLazyQuery } from '@apollo/client'

import type { ServerCart } from '../types'

const LOAD_CARTS_QUERY = gql`
  query LoadCarts {
    loadCarts {
      shop_id
      items {
        product_id
        amount
        comment
        offer_id
      }
    }
  }
`

export interface LoadCartsResponse {
  loadCarts: ServerCart[]
}

export function useFetchLoadCarts () {
  return useLazyQuery<LoadCartsResponse>(LOAD_CARTS_QUERY, {
    fetchPolicy: 'no-cache',
  })
}
